// extracted by mini-css-extract-plugin
export var md = "_1y-4";
export var semantic = "_1y-5";
export var sm = "_1y-3";
export var text = "_1y-6";
export var toggleInput = "_1y-0";
export var toggleSwitch = "_1y-1";
export var xs = "_1y-2";